import type { IAuthRepository } from '@src/domain/users/repository';

/**
 * Logout Use Case
 * Handles user logout and token cleanup
 */
export class LogoutUseCase {
    constructor(private readonly authRepository: IAuthRepository) { }

    async execute(): Promise<void> {
        await this.authRepository.logout();
    }
}
